export default class ReadMore
{
  constructor()
  {
    if (!this.setVars()) return;

    this.setEvents();
  }

  setVars()
  {
    this.bloggerVita = document.querySelector('.bloggerSingle__vitaDesc');
    if (!this.bloggerVita) return;

    this.vitaText      = this.bloggerVita.innerHTML.trim().split(' ');
    this.WORDS_LENGTH   = 0;
    this.ALLOWED_LENGTH = 999;

    return true;
  }

  setEvents()
  {
    this.checkLength();
  }

  checkLength()
  {
    this.WORDS_LENGTH = this.vitaText.length;
    if (this.WORDS_LENGTH < this.ALLOWED_LENGTH) return;

    this.trimContent();
  }

  trimContent()
  {
    this.unusedContent = this.vitaText.slice(this.ALLOWED_LENGTH, this.vitaText.length).join(' ');
    this.vitaText = this.vitaText.slice(0, this.ALLOWED_LENGTH);
    this.vitaText = this.vitaText.join(' ');
    this.bloggerVita.innerHTML = this.vitaText;

    this.createReadMore();
  }

  createReadMore()
  {
    const readMore = document.createElement('span');
    readMore.addEventListener('click', this.expandText.bind(this));
    readMore.innerHTML = `... ${window.translations.showMore}`;

    this.bloggerVita.appendChild(readMore);
  }

  expandText(event) {
    event.target.classList.add('disabled');
    this.bloggerVita.innerHTML = `${this.vitaText} ${this.unusedContent}`;
  }
}
